import { useState } from 'react'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { CompanyModalContainer } from 'components/common/modals/CompanyModalContainer'
import * as ACT from 'components/Company/actions'
import { toEditCompanyData } from 'components/Company/serializers'
import s from './CompanyActions.scss'
import cn from 'classnames'
import { withSweetAlert } from 'hocs'
import { makeDeleteRequest } from 'utils/api'
import { useDispatch } from 'react-redux'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { useNavigate } from 'react-router-dom'
import { isAdmin, getUser } from 'utils/authService'
import { NotificationList } from 'components/common/NotificationList'

const CompanyActions = ({ company }) => {
  const [showCompanyModal, setShowCompanyModal] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const toggleCompanyModal = () => setShowCompanyModal(!showCompanyModal)

  const deleteCompany = async () => {
    const sweetAlertFactory = withSweetAlert(
      <p style={{ color: 'red' }}>This action can&#39;t be reverted</p>
    )
    sweetAlertFactory(
      {
        title: 'Are you sure you want to delete company?',
        buttons: ['No', 'Yes'],
        icon: 'warning'
      },
      async () => {
        try {
          await makeDeleteRequest(`/v1/companies/${company.id}`)
          dispatch({
            type: PUSH_NOTIFICATION,
            payload: {
              title: 'The company was deleted successfully',
              level: 'success'
            }
          })
          navigate('/companies')
        } catch (e) {
          dispatch({
            type: PUSH_NOTIFICATION,
            payload: {
              title: 'There was a problem deleting company',
              message: <NotificationList lines={e.response.data} />,
              level: 'error'
            }
          })
        }
      },
      { cancelConfirmation: false }
    )
  }

  return (
    <>
      <section className={s.actionsContainer}>
        <div className={s.actionIcon} onClick={toggleCompanyModal}>
          <FaEdit />
        </div>
        {(isAdmin() || getUser().sub === company.createdBy) && (
          <div className={cn(s.actionIcon, s.deleteIcon)} onClick={deleteCompany}>
            <FaTrashAlt />
          </div>
        )}
      </section>
      <div className={s.clearfix} />
      {showCompanyModal && (
        <CompanyModalContainer
          toggleCompanyModal={toggleCompanyModal}
          showCompanyModal={showCompanyModal}
          company={toEditCompanyData(company)}
          actionType={ACT.COMPANY_UPDATE_REQUESTED}
        />
      )}
    </>
  )
}

export default CompanyActions
